// extracted by mini-css-extract-plugin
export default {"brandPromo":"KF-z","carousel":"LF-z"};